<div class="wrap uk-margin-top">
    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loading === false">
        <div class="uk-form-stacked uk-margin-large uk-grid-medium" uk-grid>
            <div *ngIf="session.role.ability !== 'user'" class="uk-width-12-12 uk-margin-small-top"
                style="padding-left: 20px;">
                <div class="back-button" [routerLink]="[routerURL]">
                    <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
                    <span>{{previousUrlName}}</span>
                </div>
            </div>
            <div class="uk-width-12-12 uk-position-relative uk-margin-top">
                <div class="main-title bold">{{ user.FirstName }} {{ user.LastName }}</div>
                <div class="uk-float-right">
                    <button class="back-button button-main-title regular" type="submit" (click)="updateUser()"
                        style="padding-right: 20px;">
                        <span class="uk-visible@s uk-text-uppercase">Valider les changements</span>
                        <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                    </button>
                </div>
            </div>
            <div uk-grid class="uk-width-12-12 padding-20 uk-margin-top vop-background-white remove-grid-ml-pl"
                style="padding-bottom: inherit;">
                <div class="uk-width-4-12@m" style="min-height: 316.66px;">
                    <div class="img-wrap">
                        <div *ngIf="loadingPhoto === true" class="uk-position-center" uk-spinner></div>
                        <div *ngIf="loadingPhoto === false" uk-lightbox>
                            <a class="uk-button uk-button-default" [href]="user.ProfilePicture">
                                <img [src]="user.ProfilePicture"
                                    onerror="this.src='../../../../assets/icons/User.svg';this.className='img-error';">
                            </a>
                        </div>
                        <button class="uk-position-absolute button large edit-button" (click)="modifyPhoto()">
                            <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                        </button>
                    </div>
                </div>
                <div class="uk-width-8-12@m uk-grid-small@m" uk-grid>
                    <div class="uk-width-1-2@s">
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Nom</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="user.LastName">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Prénom</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="user.FirstName">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">E-mail</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="user.EMailAddress">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Téléphone</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="user.Mobile">
                            </div>
                        </div>
                        <div class="uk-margin uk-margin-left">
                            <label class="label">Date d'inscription</label>
                            <div class="uk-form-controls">
                                <span humanDateFormat="{{ user.ISODateCreation }}" noDay="true" shortened="true"></span>
                            </div>
                        </div>
                    </div>

                    <div class="uk-width-1-2@s">
                        <div class="uk-margin uk-margin-left">
                            <label class="label">État du compte</label>
                            <div class="uk-form-controls">
                                <span class="color-cold-grey bold uk-width-1-1 uk-text-uppercase"
                                    *ngIf="user.IdDisabledAccount > 0">
                                    <span
                                        class="material-icons color-red vertical-align-middle">fiber_manual_record</span>
                                    <span class="vertical-align-middle" style="margin-left: 5px;">Désactivé</span>
                                </span>
                                <span class="color-cold-grey bold uk-width-1-1 uk-text-uppercase"
                                    *ngIf="user.IdDisabledAccount === 0">
                                    <span
                                        class="material-icons color-green vertical-align-middle">fiber_manual_record</span>
                                    <span class="vertical-align-middle" style="margin-left: 5px;">Activé</span>
                                </span>
                            </div>
                        </div>

                        <div class="uk-margin uk-margin-left">
                            <label class="label">Société</label>
                            <div class="uk-form-controls">
                                <span *ngIf="session.role.ability !== 'super-admin'"
                                    class="color-cold-grey bold uk-width-1-1">{{ user.CodeSociety }}</span>
                                <input *ngIf="session.role.ability === 'super-admin'"
                                    class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="user.CodeSociety">
                            </div>
                        </div>

                        <!-- <div *ngIf="session.role.ability !== 'super-admin'" class="uk-margin uk-margin-left">
                            <label class="label">Dev Société</label>
                            <div class="uk-form-controls">
                                <span *ngIf="session.role.ability !== 'super-admin'"
                                    class="color-cold-grey bold uk-width-1-1">{{ multiCode.join(", ") }}</span>
                            </div>
                        </div>

                        <div *ngIf="session.role.ability === 'super-admin'" class="uk-margin uk-margin-left">
                            <label class="label">Dev Société</label>
                            <div class="uk-form-controls">
                                <span *ngIf="session.role.ability !== 'super-admin'"
                                    class="color-cold-grey bold uk-width-1-1">{{ multiCode.join(", ") }}</span>
                                <div *ngIf="session.role.ability === 'super-admin'" class="uk-flex  uk-width-10-10">
                                    <input class="input alt color-cold-grey bold uk-width-7-10" type="text"
                                        [(ngModel)]="code">
                                    <select class="input alt color-cold-grey bold uk-width-5-10" [(ngModel)]="codeType">
                                        <option *ngFor="let soc of societies; let i = index" [value]="i">{{ soc }}
                                        </option>
                                    </select>
                                    <button (click)="addCode(code)"
                                        class="uk-button uk-button-default uk-button-small uk-width-3-10">add</button>
                                </div>
                                <div>
                                    <div class=" containerSociete">
                                        <div *ngFor="let code of multiCode; let i = index" class="item">
                                            <p>{{code.name +" - "+ societies[code.type]}}</p>
                                            <img (click)="removeCode(code)" src="../../../assets/icons/Close.svg"
                                                class="" width="32px" height="32px" alt="back">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- 
                        <div *ngIf="!editPassword" class="uk-margin uk-margin-left">
                            <label class="label">Mot de passe</label>
                            <div class="uk-form-controls uk-margin-small-bottom">
                                <span class="color-cold-grey bold uk-width-1-1">{{ password }}</span>
                            </div>
                            <button (click)="updatePassword()"
                                class="uk-button uk-button-default uk-button-small">Modifier</button>
                        </div>

                        <div *ngIf="editPassword" class="uk-margin uk-margin-left">
                            <label class="label">Mot de passe</label>
                            <div class="uk-flex uk-form-controls uk-margin-small-bottom">
                                <input class="input alt color-cold-grey bold uk-width-9-10" type="text"
                                    [(ngModel)]="passwordcreate">
                                <span class="material-icons uk-margin-small-left pointer"
                                    [attr.uk-tooltip]="'Random Password'" (click)="generatePassword()">shuffle_on</span>
                            </div>
                            <button class="uk-button uk-button-default uk-button-small"
                                (click)="this.editPassword = !this.editPassword">Annuler</button>
                            <button class="uk-button uk-button-default uk-button-small uk-margin-small-left"
                                (click)="updatePassword()">Valider</button>
                        </div> -->
                        <div class="uk-margin" *ngIf="drivingLicenseMissing === true || idCardMissing === true">
                            <div class="uk-form-controls">
                                <button class="round-button bigger"
                                    style="cursor: default; padding: 10px 15px 10px 5px !important;">
                                    <img src="../../../../assets/icons/Warning.svg" height="32px" width="32px">
                                    <span class="uk-margin-small-left color-grey bold">Documents manquants</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="title bold uk-margin-small-bottom">
                    Documents
                    <img href="#edit-user-documents" uk-toggle src="../../../assets/icons/Edit.svg" width="24px"
                        height="24px" alt="back" class="pointer">
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-2@s">
                        <div class="uk-margin">
                            <label class="label">Permis de conduire</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button [attr.disabled]="drivingLicenseMissing ? '' : null"
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                    (click)="getDrivingLicense('recto')">
                                    <span>Recto</span>
                                    <i class="material-icons uk-margin-left">add</i>
                                </button>
                                <img class="imageScale uk-margin-small-left" *ngIf="rectoPermi" src={{rectoPermi}}>
                                <button [attr.disabled]="drivingLicenseMissing ? '' : null"
                                    class="button bold uk-display-inline-block uk-margin-small-left"
                                    (click)="getDrivingLicense('verso')">
                                    <span>Verso</span>
                                    <i class="material-icons uk-margin-left">add</i>
                                </button>
                                <img class="imageScale uk-margin-small-left" *ngIf="versoPermi" src={{versoPermi}}>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-2@s">
                        <div class="uk-margin">
                            <label class="label">Justificatif d'identité</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button [attr.disabled]="idCardMissing ? '' : null"
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                    (click)="getIDCard('recto')">
                                    <span>Recto</span>
                                    <i class="material-icons uk-margin-left">add</i>
                                </button>
                                <img class="imageScale uk-margin-small-left" *ngIf="rectoCard" src={{rectoCard}}>
                                <button [attr.disabled]="idCardMissing ? '' : null"
                                    class="button bold uk-display-inline-block uk-margin-small-left"
                                    (click)="getIDCard('verso')">
                                    <span>Verso</span>
                                    <i class="material-icons uk-margin-left">add</i>
                                </button>
                                <img class="imageScale uk-margin-small-left" *ngIf="versoCard" src={{versoCard}}>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold uk-margin-small-bottom">
                    Données de facturation
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-3@s">
                        <div class="uk-margin">
                            <label class="label">Numéro de carte</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <span class="color-cold-grey bold uk-width-1-1 uk-margin-small-left">{{ creditCard
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="user.IdAccountDemo > 0" class="uk-width-12-12 padding-20 vop-background-white"
                style="margin-top: 0px;">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold uk-margin-bottom">
                    Tarifs & droits
                </div>

                <div uk-grid class="uk-width-1-1 item-list dark remove-grid-ml-pl">
                    <div class="uk-visible@s uk-width-1-12 item-column">
                        <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/Building.svg"
                            width="64px" height="64px" alt="user" />
                    </div>
                    <div class="uk-width-3-12 item-column uk-margin-small-left">
                        <span>{{ user.CodeSociety }}</span>
                    </div>
                    <div class="uk-width-expand item-column">
                        <div class="uk-text-center">
                            <button disabled
                                class="uk-button round-button bigger uk-display-inline-block mobileButton">Admin</button>
                            <button disabled
                                class="uk-button round-button bigger uk-display-inline-block uk-margin-small-left mobileButton">Tarif
                                pro</button>
                            <button [class.round-button-toggle]="user.IdAccountDemo > 0"
                                class="uk-button round-button bigger uk-display-inline-block uk-margin-small-left mobileButton">Staff</button>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="session.role.ability !== 'user'" class="uk-width-12-12 padding-20 vop-background-white"
                style="margin-top: 0px;">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold uk-margin-small-bottom">
                    Actions
                </div>

                <div class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-1">

                        <div class="uk-form-controls uk-margin-small-top">
                            <button class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                *ngIf="user.IdDisabledAccount === 0" (click)="activateUser(false)">
                                <span>Désactiver l'utilisateur</span>
                                <img src="../../../assets/icons/Close.svg" class="uk-margin-left" width="32px"
                                    height="32px" alt="back">
                            </button>
                            <button class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                *ngIf="user.IdDisabledAccount > 0" (click)="activateUser(true)">
                                <span>Activer l'utilisateur</span>
                                <img src="../../../assets/icons/OK.svg" class="uk-margin-left" width="32px"
                                    height="32px" alt="back">
                            </button>
                            <button class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                disabled>
                                <span>Supprimer l'utilisateur</span>
                                <img src="../../../assets/icons/delete.svg" class="uk-margin-left" width="32px"
                                    height="32px" alt="back">
                            </button>
                        </div>
                    </div>

                    <!-- <div class="uk-width-12-12 padding-20 vop-background-white"
                        style="margin-top: 0px; padding-bottom: 0px;">
                    </div> -->

                    <!-- Parti commentaire pas encore integré -->

                    <!-- <div class="uk-width-12-12 padding-20" style="margin-top: 0px;">
                <div class="title bold uk-margin-top uk-margin-small-bottom">Commentaire</div>
                <div class="uk-width-12-12 padding-20 vop-background-white uk-flex">
                    <input class="uk-input uk-width-10-12" type="text" placeholder="Commentaire" [(ngModel)]="comment">
                    <button class="button bold uk-display-inline-block uk-margin-small-left uk-width-2-12"
                        (click)="addComment()">
                        <span>Envoyer</span>
                    </button>
                </div>

                <div *ngFor="let comment of comments.reverse()" class="uk-width-12-12 padding-20 vop-background-white"
                    style="margin-top: 0px;">
                    <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                    <div class="title bold
                                    uk-margin-small-bottom">{{ comment.date | date:'dd/MM/yyyy hh:mm' }}</div>
                    <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                        <div class="uk-width-1-1@s">
                            <div class="uk-margin">
                                <label class="label">Commentaire</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <span class="color-cold-grey bold uk-width-1-1 uk-margin-small-left">{{
                                        comment.message }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

                    <!-- Parti commentaire pas encore integré -->

                    <div class="uk-width-12-12 padding-20" style="margin-top: 0px;">
                        <div class="title bold uk-margin-top uk-margin-medium-bottom">Historique des réservations</div>

                        <div *ngIf="noResult === true">
                            Pas de réservations.
                        </div>

                        <div *ngIf="loadingStatus === true">
                            <div uk-spinner class="uk-text-center uk-width-1-1"></div>
                        </div>

                        <div *ngIf="loadingStatus === false && noResult === false"
                            class="remove-grid-ml-pl uk-margin-remove-top" uk-grid>
                            <div uk-grid *ngFor="let reservation of reservations; let i = index"
                                class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                                [routerLink]="['/reservation/informations', reservation.Id]"
                                [queryParams]="{from: '/user/informations/'+id, name: user.LastName + ' ' + user.FirstName}">
                                <div class="item-column bold" style="font-size: 17px;">
                                    <div class="uk-display-block">
                                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}"
                                            noDay="true" shortened="true"></span>
                                        <span class="uk-text-small uk-margin-small-left regular"
                                            hours="{{ reservation.ISODateStart }}"></span>
                                    </div>
                                    <div class="uk-display-block">
                                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}"
                                            noDay="true" shortened="true"></span>
                                        <span class="uk-text-small uk-mmargin-small-left regular"
                                            hours="{{ reservation.ISODateEnd }}"></span>
                                    </div>
                                    <!-- <div class="separator"></div> -->
                                </div>
                                <div class="uk-width-expand item-column"></div>
                                <div class=" item-column light uk-text-uppercase uk-text-center"
                                    style="font-size: 17px;">
                                    {{ reservation.Vehicle }}
                                </div>
                                <!-- <div class="uk-width-1-6 item-column bold uk-text-uppercase" style="font-size: 13px;">
                            {{ reservation.User }}
                        </div> -->
                                <!-- <div *ngIf="reservation.demo === true" class="item-column light uk-text-uppercase"
                            style="font-size: 13px;">
                            Staff
                        </div> -->
                                <div *ngIf="session.role.ability === 'super-admin'"
                                    class="uk-width-1-6 item-column light uk-text-uppercase" style="font-size: 13px;">
                                    {{ reservation.CodeSociety }}
                                </div>
                                <div class="uk-width-expand item-column"></div>
                                <div class="item-column" style="font-size: 15px;"
                                    [class.color-green]="reservation.Status == 14"
                                    [class.color-orange]="reservation.Status == 12">
                                    #{{ reservation.Code }}
                                </div>
                            </div>
                        </div>

                        <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

                        <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
                            <div class="uk-position-center">
                                <button class="uk-button button"
                                    (click)="getReservationsHistory(currentPage - 1)">Précédent</button>
                                <div class="uk-display-inline-block"
                                    *ngFor="let item of [].constructor(maxPages); let i = index;">
                                    <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}
                                    </div>
                                    <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue"
                                        (click)="getReservationsHistory(i + 1)">{{i + 1}}</div>
                                </div>
                                <button class="uk-button button uk-margin-left"
                                    (click)="getReservationsHistory(currentPage + 1)">Suivant</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-edit-user-documents [id]="id" (changed)="loadInformations()"></app-edit-user-documents>